import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";

import { Reveal, RevealStagger, RevealItem } from "@/components/Reveal";
import { PRODUCTS } from "@/lib/site";

export default function ProductCategories() {
  return (
        <section data-testid="categories-section" className="relative py-24 md:py-36 bg-charcoal text-white overflow-hidden">
        {/* PRODUCT CATEGORIES */}
        <div className="grain absolute inset-0" />
        <div className="absolute top-1/3 -left-40 w-[400px] h-[400px] rounded-full bg-stenzia-green/15 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <Reveal>
              <div className="overline text-stenzia-gold"><span className="kbd-line" /> Product Categories</div>
              <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-[64px] tracking-tighter leading-[1.02]">
                Five display series.<br />One engineering standard.
              </h2>
            </Reveal>
            <Reveal delay={1}>
              <Link to="/products" data-testid="categories-view-all" className="btn-ghost-light group">
                View all products <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </Reveal>
          </div>

          <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {PRODUCTS.map((p) => (
              <RevealItem key={p.slug}>
                <Link
                  to="/products"
                  data-testid={`product-card-${p.slug}`}
                  className="group relative block rounded-2xl overflow-hidden bg-[#161616] border border-white/8 transition-all duration-500 hover:border-stenzia-gold/40 hover:-translate-y-1"
                >
                  {/* Animated gold border on hover */}
                  <div className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "linear-gradient(135deg, rgba(201,162,39,0.4), transparent 40%, transparent 60%, rgba(201,162,39,0.4))", padding: "1px", WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)", WebkitMaskComposite: "xor", maskComposite: "exclude" }} />

                  <div className="aspect-[4/5] overflow-hidden bg-charcoal">
                    <img
                      src={p.image}
                      alt={p.name}
                      loading="lazy"
                      className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-[1200ms] ease-out"
                    />
                  </div>
                  <div className="absolute top-4 left-4 px-3 py-1 rounded-full text-[10px] tracking-[0.18em] uppercase font-semibold bg-stenzia-gold text-charcoal shadow-lg">{p.tag}</div>
                  <div className="p-6 md:p-7">
                    <h3 className="font-display text-xl md:text-2xl tracking-tight">{p.name}</h3>
                    <p className="mt-2 text-sm text-white/55 leading-relaxed">{p.short}</p>
                    <div className="mt-5 flex items-center justify-between text-xs">
                      <span className="text-white/40">{p.capacity}</span>
                      <span className="inline-flex items-center gap-1.5 text-stenzia-gold group-hover:gap-3 transition-all duration-500 font-medium">Explore <ArrowRight size={14} /></span>
                    </div>
                  </div>
                </Link>
              </RevealItem>
            ))}
          </RevealStagger>
        </div>
      </section>

  );
}
